import { Component, OnInit, Inject, Input } from '@angular/core';
import { Router, NavigationStart, RouterLink, RouterLinkActive } from '@angular/router';
import { environment } from 'src/environments/environment';
// Services
import { AuthenticationService } from 'src/app/services/auth/authentication.service';
import { SharedService } from '../../services/api/message.service';

// models
import { SchoolData } from 'src/app/models/schoolUser';
import { CommonService } from 'src/app/services/api/common.service';
import { Subscription } from 'rxjs';
import { Intercom } from '@supy-io/ngx-intercom';
import { MixpanelService } from 'src/app/mixpanel.service';
import { SwichBackToPythonComponent } from '../swich-back-to-python/swich-back-to-python.component';
import { NgClass, NgIf } from '@angular/common';
import { CommonAnnouncementComponent } from 'src/app/pages/common/common-announcement/common-announcement.component';
import { BrazeService } from 'src/app/braze.service';
import { ProfileService } from 'src/app/services/api/consumer/profile.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-public-header',
  standalone: true,
  imports: [NgClass, NgIf, RouterLink, RouterLinkActive, SwichBackToPythonComponent, CommonAnnouncementComponent],
  templateUrl: './public-header.component.html',
  styleUrl: './public-header.component.scss'
})
export class PublicHeaderComponent {
  @Input() announcementData = '';

}
